export default "__VITE_ASSET__BH4pAno6__"